<template>
  <section class="page-body">
    <v-dialog class="ma-0 pa-0" width="900px" v-model="showDialog" scrollable>
      <template v-if="showDialog">
        <Beneficiary
          @closeDialog="closeDialog"
          @getBenficiary="getBenficiary()"
          :showDialog="showDialog"
          :getrecieverDetails="is_edit ? beneficiaryData : {}"
          :cust_id="$route.query.cust_id"
        />
      </template>
    </v-dialog>

    <v-dialog
      class="ma-0 pa-0"
      width="900px"
      v-model="showBusDialog"
      scrollable
    >
      <template v-if="showBusDialog">
        <BusBeneficiary
          @closeBusDialog="closeBusDialog"
          @getBenficiary="getBenficiary()"
          :beneficiarybusData="is_edit_bus ? beneficiarybusData : {}"
          :cust_id="$route.query.cust_id"
          :showBusDialog="showBusDialog"
        />
      </template>
    </v-dialog>
    <v-card class="bg-color">
      <v-row>
        <v-col lg="6" sm="12">
          <v-menu :offset-x="true" open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                <v-icon dark left>mdi-account-plus </v-icon>
                {{ $t("add_bene_label") }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item link @click="onAddBen">
                <v-list-item-title
                  ><v-icon class="mb-1 me-2"> mdi-account-tie</v-icon>
                  {{ $t("personal") }}</v-list-item-title
                >
              </v-list-item>
              <v-list-item link @click="onAddBusBen">
                <v-list-item-title
                  ><v-icon class="mb-1 me-2">mdi-briefcase-account</v-icon
                  >{{ $t("business") }}</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-spacer></v-spacer>
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          :label="$t('search')"
          single-line
          hide-details
        ></v-text-field>
      </v-row>
      <v-data-table fixed-header  height="55vh" :items="userItems" :headers="headers" :search="filter">
        <template v-slot:item.bank="{ item }">
          <span>
            {{ item.location_name ? item.location_name : "" }}
          </span>
          <p
            v-if="item.payment_code && item.payment_code.payment_mode_code == 'B'"
            class="mb-0"
          >
            Account No: {{ item.bank_account_no }}
          </p>
          <p
            v-if="item.payment_code && item.payment_code.payment_mode_code == 'B'"
            class="mb-0"
          >
            Branch Code: {{ item.branch_code }}
          </p>
        </template>
        <template v-slot:item.full_name="{ item }">
          <span class="font-weight-bold">{{ item.full_name }}</span>
          <p class="mb-0">
            {{ item.relationship_code ? item.relationship_code.value : "" }}
          </p>
        </template>
        <template v-slot:item.country_code="{ item }">
          <p class="mb-0">
            {{ item.country_code ? item.country_code.name : "" }}
          </p>
        </template>
        <template v-slot:item.payment_code="{ item }">
          <p class="mb-0">
            {{ item.payment_code ? item.payment_code.payment_mode : "" }}
          </p>
        </template>
        <template v-slot:item.rec_type="{ item }">
          <v-chip v-if="item.rec_type" small outlined>
            {{ item.rec_type ? item.rec_type : "" }}
          </v-chip>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              class="mr-2 action-btn"
              :title="$t('update_bene_lable')"
              @click="editRemittee(item)"
              icon
            >
              <v-icon>mdi-account-edit</v-icon>
            </v-btn>
            <v-btn
              class="mr-2 action-btn"
              :title="$t('delete_bene_label')"
              @click="openDialogCOnfirmation(item)"
              icon
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Delete confirmation popup dialog -->
    <v-dialog v-model="openDialog" width="500">
      <v-card>
        <v-card-title class="border border-bottom">
          {{ $t("delete_beneficary") }}</v-card-title
        >
        <!-- <v-divider></v-divider> -->
        <v-card-text class="h5 py-3">
          {{ $t("are_you sure want_to_delete_beneficary") }}
          <strong>{{ remitee_selected.first_name }} </strong>?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            outlined
            @click="onDeleteDetil"
          >
            {{ $t("yes") }}<v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            outlined
            @click="openDialog = false"
            >{{ $t("no") }} <v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import remitteService from "@/services/RemitteService/remitteService.js";
import Beneficiary from "@/views/beneficiary/Beneficiary.vue";
import BusBeneficiary from "@/views/beneficiary/BenificiaryBus.vue";
export default {
  mixins: [alerts],
  name: "Beneficiary Summary",
  data() {
    return {
      isexceedBenelimit: false,
      beneficiarybusData: {},
      beneficiaryData: {},
      filter: null,
      customer_name: "",
      headers: [
        {
          text: "Receiver Name",
          value: "full_name",
          align: "left",
        },
        {
          text: "Country",
          value: "country_code",
          align: "left",
        },
        {
          text: "Receiver Type",
          value: "rec_type",
          align: "left",
        },
        {
          text: "Bank Details",
          value: "bank",
          align: "left",
        },
        {
          text: "Payment Type",
          value: "payment_code",
          align: "left",
        },
        {
          text: "Currency",
          value: "currency_code",
          align: "left",
        },
        {
          text: this.$t("action"),
          value: "action",
          align: "center",
        },
      ],
      userItems: [],
      loader: false,
      fullPage: true,
      height: 100,
      width: 100,
      openDialog: false,
      remitee_selected: {},
      showDialog: false,
      showBusDialog: false,
      receiver_id:null,
      is_edit: false,
      is_edit_bus: false,
      country_obj: [],
    };
  },
  components: { Beneficiary, BusBeneficiary },
  async mounted() {
    if (this.$route.query.name) {
      this.customer_name = this.$route.query.name;
    }
    await this.getBenficiary();
  },
  methods: {
    closeDialog(val) {
      console.log(val);
      this.showDialog = val;
    },
    closeBusDialog(val) {
      console.log(val);
      this.showBusDialog = val;
    },
    onAddBen() {
      this.showDialog = true;
      this.$store.state.showDialog = true;
      this.is_edit = false;
      // this.$router.push("/beneficiary/true");
    },
    onAddBusBen() {
      this.showBusDialog = true;
      this.$store.state.showDialog = true;
      this.is_edit_bus = false;
      // this.$router.push("/beneficiary/true");
    },
    async getBenficiary() {
      try {
        const responseData = await remitteService.getBenificiaryData(
            this.$route.query.customerid
          );
        console.log("responseData.data", responseData.data);
        if (responseData.data.status_code === 200) {
          console.log("responseData.data", responseData.data);
          this.userItems = [...responseData.data.data[0].reverse()];
        } else {
          this.showAlertError(
            `Fetching Data Failed: ${responseData.data.message}`
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    openDialogCOnfirmation(remitee) {
      console.log("logss", remitee);
      this.remitee_selected = remitee;
      this.receiver_id=remitee.receiver_id
      this.openDialog = true;
    },
    async onDeleteDetil() {
      try {
        this.openDialog = false;
        this.loader = true;
        const responseData = await remitteService.deleteBenificiaryData(
            this.receiver_id,
            this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid
          );
        if (responseData && responseData.data.status_code === 200) {
          this.getBenficiary();
          this.loader = false;
          this.showAlertSuccess(this.$t("beneficiary_delete_success_msg"));
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    async info(item) {
      console.log("item: ", item);
      this.loader = true;
      try {
        const responseData = await this.$store.dispatch(
          "Remittee/getRemitteDetailByID",
          item.receiver_id
        );
        console.log("res start", responseData);
        if (responseData.data.status_code === 200) {
          this.loader = false;
          //to send selected bene data to the send money page
          this.$store.state.data = responseData.data.data[0];
          this.$router.push("/transaction");
        } else {
          this.loader = false;
          this.alertMsg = {
            status: true,
            text: "something went wrong.",
            color: "warning",
            type: "warning",
          };
        }
      } catch (err) {
        this.loader = false;
        console.log(err);
      }
    },
    editRemittee(item) {
      console.log("item.data==>",item)
      if (item.rec_type === "Business") {
        this.is_edit_bus = true;
        this.showBusDialog = true;
        this.beneficiarybusData = item;
      } else {
        this.is_edit = true;
        this.showDialog = true;
        this.beneficiaryData = item;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/global.scss";
.row {
  margin: 5px;
}
.action-btn {
  // background: $primary;
  border-radius: 4px;
  // color: $white !important;
  border: none !important;
}
.action-btn:hover {
  color: $primary !important;
}
.action-div {
  text-align: end;
}
::v-deep .table {
  td {
    vertical-align: middle !important;
  }
}

::v-deep th {
  color: $txt !important;
  font-size: 14px;
  font-weight: 600;
}

.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  height: auto !important;
  min-height: 2px !important;
}
.v-application--is-ltr .v-data-table__mobile-row__cell {
  text-align: left !important;
}
.text-col {
  color: rgb(130, 127, 127);
  font-size: 12px;
}
.center {
  justify-content: center;
  align-items: center;
}
.flag-style {
  font-size: 46px;
  border-radius: 50%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.flag-size {
  font-size: 33px;
  border-radius: 50%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.width-100 {
  width: 78vw;
}
.font {
  font-size: 9px;
}
.font-name {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 700;
}
</style>
